<ion-app>
  <!-- ASZTALI töltő-fátyol: a route-váltás / lusta modulbetöltés fehér villanását takarja.
       CSAK az asztali programban jelenhet meg (asztaliFatyol csak ott lesz true) – weben soha. -->
  <div class="asztali-fatyol" [class.lathato]="asztaliFatyol" *ngIf="asztaliMod" aria-hidden="true">
    <div class="asztali-fatyol-jel"></div>
  </div>

  <!-- Globális betöltésjelző: vékony animált sáv a képernyő tetején, amíg API-kérés fut -->
  <div class="global-loading-bar" *ngIf="loading.active$ | async"></div>

  <!-- INDULÁSI HIBA
       Ha a bejelentkezés nem áll helyre, eddig ÜRES képernyő maradt: se tartalom,
       se hibaüzenet, se gomb. A felhasználó egy fehér lapot látott, és nem tudta,
       várjon-e, frissítsen-e, vagy elromlott-e valami. -->
  <div *ngIf="bootHiba"
       style="position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;
              background:#fff;padding:24px;text-align:center">
    <div style="max-width:420px">
      <ion-icon name="alert-circle" style="font-size:44px;color:#c0392b"></ion-icon>
      <p style="margin:14px 0 18px;font:400 15px/1.5 system-ui,sans-serif;color:#333">{{ bootHiba }}</p>
      <ion-button expand="block" (click)="ujraBelepes()">Bejelentkezés újra</ion-button>
      <ion-button expand="block" fill="clear" (click)="oldalFrissites()">Oldal frissítése</ion-button>
    </div>
  </div>

  <!-- FRISSÍTÉS ELÉRHETŐ – csak adminisztrátornak.
       Jól látható helyen kell lennie: ha csak egy admin-almenüben állna, sosem
       derülne ki, hogy hetek óta van újabb verzió. -->
  <div class="frissites-sav" *ngIf="frissitesElerheto" (click)="frissitesreUgras()">
    <ion-icon name="cloud-download-outline"></ion-icon>
    <span>
      <b>Frissítés érhető el:</b> {{ frissitesElerheto.legujabb }}
      <span class="halvany" *ngIf="frissitesElerheto.jelenlegi">(jelenlegi: {{ frissitesElerheto.jelenlegi }})</span>
    </span>
    <ion-button size="small" fill="solid" color="light">Megnézem</ion-button>
    <ion-button size="small" fill="clear" color="light" (click)="frissitesSavElrejt($event)"
                title="Elrejtés mára">
      <ion-icon slot="icon-only" name="close"></ion-icon>
    </ion-button>
  </div>

  <!-- PDF-motor (LibreOffice) beszerzés toast a jobb alsó sarokban -->
  <div class="pdfmotor-toast" *ngIf="pdfMotor.show" [class.kesz]="pdfMotor.kesz" [class.hiba]="pdfMotor.hiba">
    <div class="pm-fej">
      <ion-icon [name]="pdfMotor.hiba ? 'alert-circle' : (pdfMotor.kesz ? 'checkmark-circle' : 'cloud-download')"></ion-icon>
      <span>{{ pdfMotor.uzenet }}</span>
    </div>
    <div class="pm-bar" *ngIf="!pdfMotor.kesz && !pdfMotor.hiba">
      <div class="pm-fill" [style.width.%]="pdfMotor.allapot === 'kicsomagolas' ? 100 : pdfMotor.szazalek"
        [class.indet]="pdfMotor.allapot === 'kicsomagolas'"></div>
    </div>
    <div class="pm-pct" *ngIf="pdfMotor.allapot === 'letoltes'">{{ pdfMotor.szazalek }}%</div>
  </div>
  <!-- MODUL TÉMÁJA (modul-tema.ts): Fókuszban a bal sáv nem foglal helyet – a modul saját fejléce
       navigál, a profil, az intézmény- és a modulváltás a fejléc lenyílójában van; mobilon a bal
       sáv a hamburger-gombbal nyílik. Klasszikusban (és minden Fókusz-keret nélküli modulban)
       változatlanul a bal sáv. -->
  <!--  AZ ADMINBAN SINCS BAL SÁV (2026-10-16, a user: „különben nem fogunk elférni”): az admin
        saját területlistája navigál, a fejlécben vissza gomb és profil-lenyíló (admin-layout). -->
  <ion-split-pane contentId="main-content" [disabled]="menuRejtve">
    <!--  Fókusz témában a bal menü TELJESEN ki van kapcsolva (nem csak elrejtve): különben a képernyő
          széléről véletlenül kihúzható volt (user, 2026-10-07). Ott a saját főmenü navigál. -->
    <ion-menu class="hidePrint" [class.fokusz-menu]="fokusz" contentId="main-content" type="overlay" style="max-width: 280px"
              [disabled]="menuRejtve" [swipeGesture]="!menuRejtve">
      <!-- Az oldalmenünek nincs headere, ezért a safe-area (notch/dynamic island + home indicator) alá igazítjuk. -->
      <ion-content style="--padding-top: env(safe-area-inset-top); --padding-bottom: env(safe-area-inset-bottom);">
        <ion-list id="inbox-list" style="border-radius: 20px;padding:5px">
          <div *ngIf="user$ && userMetadata && sajatIntezmeny">
            <div class="row" style="display:flex">
              <ion-avatar class="avatar col-6 online1" style="text-align: center; margin: auto">
                <img [src]="getUserProfilePictureUrl()"
                  [alt]="userMetadata.viselt_ker"
                  (error)="useGeneratedAvatar($event)" />
              </ion-avatar>
              <ion-avatar class="avatar col-6" style="text-align: center; margin: auto; background: #F9F9F9 !important">
                <img *ngIf="sajatIntezmeny" [src]="sajatIntezmeny.intezmenyKep || 'assets/default-intezmeny.svg'" width="100%"
                  [alt]="sajatIntezmeny.intezmenyName" (error)="useDefaultIntezmenyKep($event)" />
              </ion-avatar>
            </div>
            <ion-list-header style="color:var(--menu-szoveg, #F9F9F9)!important;text-align: center !important;">{{ userMetadata.viselt_vez
              }} {{ userMetadata.viselt_ker }}</ion-list-header>
            <!--ion-note *ngIf="sajatIntezmeny" style="color:var(--menu-szoveg, #F9F9F9)!important;margin-bottom:0px;">{{ sajatIntezmeny.munkakor }}</ion-note-->
            <ion-note (click)="select.open()" style="text-align: center;margin-bottom:0px;">
              <small><app-searchable-select #select title="Intézmény kiválasztása" [data]="intezmenyek"
                  [placeholderText]="sajatIntezmeny.intezmenyName" [itemTextField]="'intezmenyName'"
                  (selectedChanged)="selectChangedIntezmeny($event)" [multiple]="false"
                  style="cursor:pointer"></app-searchable-select><ion-button size="small"
                  style="font-size: 8px;margin-top: -5px;" fill="clear"><ion-icon slot="icon-only"
                    name="caret-down-outline"></ion-icon></ion-button></small>
            </ion-note>
            <!--  Más rendszerek intézményei (tobbintezmeny.js): két munkahely, vagy két iskolába járó gyerekek. -->
            <app-tobb-intezmeny [sotet]="!keretVilagos" style="display:block;margin:0 8px 6px"></app-tobb-intezmeny>
            <!-- Alrendszer-váltó – fixált alrendszernél (több-app matrix) elrejtve, mert az app EGY alrendszerre szól. -->
            <ion-note *ngIf="!fixedMode" (click)="select2.open()" style="text-align: center;margin-bottom:5px;">
              <small><app-searchable-select #select2 title="Üzemmód váltása" [data]="modes"
                  [placeholderText]="modeNev(currentMode)" [itemTextField]="'cim'"
                  (selectedChanged)="selectChangedUzemmod($event)" [multiple]="false"
                  style="cursor:pointer"></app-searchable-select><ion-button size="small"
                  style="font-size: 8px;margin-top: -5px;" fill="clear"><ion-icon slot="icon-only"
                    name="caret-down-outline"></ion-icon></ion-button></small>
            </ion-note>
            <!-- A téma már nem itt választható (túl sok helyet foglalt): a felhasználó a Beállítások
                 oldalon (/beallitasok) választja, az alapértelmezést az admin (Admin › Modulok témája). -->
            <ion-note (click)="select3.open()" style="text-align: center;margin-bottom:5px;"
              *ngIf="tanevadatok&&currentMode=='SULINFORM'">
              <small><app-searchable-select #select3 title="Tanév kiválasztása" [data]="tanevadatok"
                  [placeholderText]="munkatanevNev()" [itemTextField]="'name'"
                  (selectedChanged)="selectChangedTanev($event)" [multiple]="false"
                  style="cursor:pointer"></app-searchable-select><ion-button size="small"
                  style="font-size: 8px;margin-top: -5px;" fill="clear"><ion-icon slot="icon-only"
                    name="caret-down-outline"></ion-icon></ion-button></small>
            </ion-note>

            <!--  JOGKÖR-NÉZET. Csak akkor van értelme felkínálni, ha tényleg van miből
                  választani (egy jogkörnél nincs mire váltani). A váltás nem csak a
                  menüt cseréli: a kiszolgáló is azzal az egy jogkörrel számol. -->
            <ion-note (click)="select4.open()" style="text-align: center;margin-bottom:5px;"
              *ngIf="jogkorNezetValaszthato.length > 1">
              <small><app-searchable-select #select4 title="Jogkör-nézet váltása"
                  [data]="jogkorNezetValaszthato"
                  [placeholderText]="jogkorNezet ? jogkorNezetNev() : 'Teljes jogkör'"
                  [itemTextField]="'cim'"
                  (selectedChanged)="jogkorNezetValaszt($event)" [multiple]="false"
                  style="cursor:pointer"></app-searchable-select><ion-button size="small"
                  style="font-size: 8px;margin-top: -5px;" fill="clear"><ion-icon slot="icon-only"
                    name="caret-down-outline"></ion-icon></ion-button></small>
            </ion-note>

            <ion-note style="text-align: justify;margin-bottom:0px;" *ngIf="kivceg">
              <small><strong>Kiválasztott cég: </strong>{{kivceg.NEV}}</small>
            </ion-note>
            <!--ion-note *ngIf="sajatIntezmeny">{{ sajatIntezmeny.intezmenyName }}</ion-note-->
          </div>
          <div *ngIf="(isLoggedIn) === false">
            <ion-list-header>Bejelentkezés szükséges</ion-list-header>
            <ion-note></ion-note>
          </div>
          <!-- Fixált alrendszer (több-app matrix): a belépett usernek nincs ilyen alrendszerű intézménye. -->
          <div *ngIf="isLoggedIn && fixedMode && !sajatIntezmeny" style="text-align:center;padding:10px">
            <ion-list-header style="color:var(--menu-szoveg, #F9F9F9)!important;text-align:center!important">Nincs elérhető intézmény</ion-list-header>
            <ion-note style="color:var(--menu-szoveg, #F9F9F9)!important;display:block;margin-bottom:10px">
              Ehhez a fiókhoz nincs <b>{{ modeNev(fixedMode) }}</b> alrendszerű intézmény ebben az appban.
              Használd a megfelelő appot, vagy jelentkezz ki.
            </ion-note>
            <ion-button expand="block" fill="outline" color="light" (click)="auth.logout()">Kijelentkezés</ion-button>
          </div>

          <!--  A GYŰJTŐ FEJLÉCE NEM CSUKJA BE A MENÜT. Az egész blokk egy ion-menu-toggle-ben van
                (a navigáló elemekre ez csukja be telefonon az oldalsávot); a fejléc kattintását
                viszont megállítjuk, mielőtt odaér – így a csoport kinyílik, a menü nyitva marad.
                (Egy korábbi, átszerkesztett változatban a csoport nem nyílt ki.) -->
          <ng-container *ngFor="let p of appPages; let i = index">
          <!-- BÉR: az Átalányadós menüpont csak átalányadózó ügyfélnél; a régi cégautós pontok (Gépjármű modulba költöztek) nem -->
          <ion-menu-toggle auto-hide="false" *ngIf="berMenuLathato(p.url)">
            <ion-item *ngIf="!p.external && p.url[0] != '0'" routerDirection="root" [routerLink]="[p.url]" lines="none"
              detail="false" routerLinkActive="selected" [disabled]="p.disabled"
              [class.hianyzo-beallitas]="kretaMenu(p.url) && kretaHianyzik">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">{{ p.title }}</ion-label>
              <!-- Olvasatlan üzenetek: a menüben is látszódjon, ne csak megnyitás után -->
              <ion-badge slot="end" color="danger" *ngIf="uzenetMenu(p.url) && olvasatlanUzenet">
                {{ olvasatlanUzenet }}
              </ion-badge>
              <!-- Hibajelentés: a saját jegyek olvasatlan változásai (állapot, válasz) -->
              <ion-badge slot="end" color="warning" *ngIf="adatjavitasMenu(p.url) && atnezetlenAdatjavitas"
                [title]="atnezetlenAdatjavitas + ' át nem nézett adathiba-bejelentés'">{{ atnezetlenAdatjavitas }}</ion-badge>
              <ion-badge slot="end" color="danger" *ngIf="hibajegyMenu(p.url) && olvasatlanHibajegy">
                {{ olvasatlanHibajegy }}
              </ion-badge>
              <!-- Új verzió: a jelvény akkor is emlékeztet, ha a felső sávot elrejtették. -->
              <ion-badge slot="end" color="warning" *ngIf="frissitesMenu(p.url) && ujVerzio"
                [title]="'Frissítés érhető el: ' + ujVerzio">új</ion-badge>
            </ion-item>
            <ion-item *ngIf="p.external && p.url[0] != '0'" style="cursor: pointer" lines="none" detail="false"
              routerDirection="root" routerLinkActive="selected" (click)="openWindow(p.url)" [disabled]="p.disabled">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">{{ p.title }}</ion-label>
            </ion-item>
            <ion-item *ngIf="p.url[0] == '0'" style="cursor: pointer" lines="none" detail="false"
              (click)="$event.stopPropagation(); p.nyitva = !p.nyitva" [disabled]="p.disabled">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="p.icon + '-outline'"
                [md]="p.icon + '-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">{{ p.title }}</ion-label>
              <!-- Összecsukva a fejlécen jelzünk, különben a jelvény pont ott rejtőzne el. -->
              <ion-badge slot="end" color="warning" *ngIf="!p.nyitva && frissitesCsoport(p) && ujVerzio"
                [title]="'Frissítés érhető el: ' + ujVerzio">új</ion-badge>
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" slot="end" [name]="p.nyitva ? 'chevron-up-outline' : 'chevron-down-outline'"></ion-icon>
            </ion-item>

            <div [id]="'slide-'+i" class="slide" [class.nyitva]="p.nyitva">
              <ion-item *ngFor="let s of p.submenu; let j = index" class="almenu-elem"
                routerDirection="root" [routerLink]="[s.url]"
                lines="none" detail="false" routerLinkActive="selected" [disabled]="s.disabled"
                [class.hianyzo-beallitas]="kretaMenu(s.url) && kretaHianyzik">
                <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="s.icon + '-outline'"
                  [md]="s.icon + '-sharp'"></ion-icon>
                <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">{{ s.title }}</ion-label>
                <ion-badge slot="end" color="danger" *ngIf="uzenetMenu(s.url) && olvasatlanUzenet">
                  {{ olvasatlanUzenet }}
                </ion-badge>
                <ion-badge slot="end" color="warning" *ngIf="adatjavitasMenu(s.url) && atnezetlenAdatjavitas"
                [title]="atnezetlenAdatjavitas + ' át nem nézett adathiba-bejelentés'">{{ atnezetlenAdatjavitas }}</ion-badge>
                <ion-badge slot="end" color="danger" *ngIf="hibajegyMenu(s.url) && olvasatlanHibajegy">
                  {{ olvasatlanHibajegy }}
                </ion-badge>
                <ion-badge slot="end" color="warning" *ngIf="frissitesMenu(s.url) && ujVerzio"
                  [title]="'Frissítés érhető el: ' + ujVerzio">új</ion-badge>
              </ion-item>
            </div>


          </ion-menu-toggle>
          </ng-container>
          <ion-item button lines="none" detail="false"
            *ngIf="(isLoggedIn) === false" (click)="login()">
            <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="'log-in-outline'"
              [md]="'log-in-sharp'"></ion-icon>
            <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Bejelentkezés</ion-label>
          </ion-item>
          <ion-item button lines="none" detail="false"
            *ngIf="(isLoggedIn) === false" (click)="logout()">
            <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="'log-out-outline'"
              [md]="'log-out-sharp'"></ion-icon>
            <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Kijelentkezés</ion-label>
          </ion-item>
          <!-- A felhasználó saját beállításai (téma, a menü és a fejléc színe) – beallitasok.component. -->
          <ion-menu-toggle auto-hide="false" *ngIf="isLoggedIn">
            <ion-item routerDirection="root" [routerLink]="['/beallitasok']" routerLinkActive="selected" lines="none" detail="false">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="'settings-outline'"
                [md]="'settings-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Beállítások</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <ion-item button lines="none" detail="false"
            *ngIf="isLoggedIn" (click)="logout()">
            <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start" [ios]="'log-out-outline'"
              [md]="'log-out-sharp'"></ion-icon>
            <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Kijelentkezés</ion-label>
          </ion-item>
        </ion-list>
        <br>
        <ion-list id="labels-list" style="border-radius: 20px;padding:5px">
          <!--ion-list-header style="var(--ion-background-color, #fff) !important;">{{environment.version}} © Cronomit Group</ion-list-header-->
          <ion-item lines="none" detail="false" style="color:var(--menu-szoveg, #F9F9F9)!important;">
            <!-- A TÉNYLEGESEN futó verzió, a kiszolgálótól. A build-idejű állandó
                 hónapokig ugyanazt mutatta, függetlenül attól, mi futott. -->
            <span *ngIf="futoVerzio">{{ futoVerzio }} © Cronomit Group</span>
            <span *ngIf="verzioIsmeretlen" title="A telepítés nem adta át a képfájl címkéjét (APP_VERZIO)">
              ismeretlen verzió © Cronomit Group
            </span>
            <span *ngIf="!futoVerzio && !verzioIsmeretlen">© Cronomit Group</span>
          </ion-item>
          <!-- Akadálymentesítési nyilatkozat (2018. évi LXXV. tv.) – nyilvános oldal, belépve és kilépve is. -->
          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" routerLink="/akadalymentesseg" lines="none" detail="false">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start"
                [ios]="'accessibility-outline'" [md]="'accessibility-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Akadálymentesítési nyilatkozat</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- Az intézmény adatkezelési szabályzata / tájékoztatója (Nkt. 43. § (1)) – nyilvános oldal, belépve és kilépve is. -->
          <ion-menu-toggle auto-hide="false">
            <ion-item routerDirection="root" routerLink="/adatkezeles" lines="none" detail="false">
              <ion-icon style="color:var(--menu-szoveg, #F9F9F9)!important;" aria-hidden="true" slot="start"
                [ios]="'shield-checkmark-outline'" [md]="'shield-checkmark-sharp'"></ion-icon>
              <ion-label style="color:var(--menu-szoveg, #F9F9F9)!important;">Adatkezelési szabályzat</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!--ion-item *ngFor="let label of labels" lines="none">
            <ion-icon aria-hidden="true" slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
            <ion-label>{{ label }}</ion-label>
          </ion-item-->
        </ion-list>
        <!--ion-list id="labels-list">
          <ion-list-header>Labels</ion-list-header>

          <ion-item *ngFor="let label of labels" lines="none">
            <ion-icon aria-hidden="true" slot="start" ios="bookmark-outline" md="bookmark-sharp"></ion-icon>
            <ion-label>{{ label }}</ion-label>
          </ion-item>
        </ion-list-->
        <!--div style="margin-top: 15px; text-align: center">
          <img width="200px" src="../assets/icon/vszc_logo-2.png" />
        </div-->

      </ion-content>
    </ion-menu>
    <div id="main-content" class="imp-burok">
      <!-- BELÉPÉS MÁS NEVÉBEN: állandóan látszik, hogy nem a saját nézetünkben vagyunk.
           Enélkül könnyű elfelejteni, és idegen névvel rögzíteni valamit. -->
      <div class="imp-sav" *ngIf="impersonalas">
        <ion-icon name="eye-outline"></ion-icon>
        <span class="imp-szoveg">
          <b>{{ impersonalas.cel_nev || impersonalas.cel }}</b> nézetében vagy
          <small>({{ impersonalas.tipus }}) – a háttérben a saját jogosultságod érvényes</small>
        </span>
        <ion-button size="small" fill="solid" color="light" (click)="impersonalasVege()">
          <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>Vissza a saját fiókomba
        </ion-button>
      </div>
      <!-- JOGKÖR-NÉZET: itt a jogosultság IS szűkítve van, nem csak a menü.
           Ezt ki kell írni, különben a „miért nem enged be" fél óra keresés. -->
      <div class="imp-sav jogkor-sav" *ngIf="jogkorNezet">
        <ion-icon name="shield-half-outline"></ion-icon>
        <span class="imp-szoveg">
          <b>{{ jogkorNezetNev() }}</b> jogkörrel dolgozol
          <small>– a jogosultságod is erre van szűkítve, nem csak a menü</small>
        </span>
        <ion-button size="small" fill="solid" color="light" (click)="jogkorNezetVege()">
          <ion-icon slot="start" name="arrow-undo-outline"></ion-icon>Vissza a teljes jogkörhöz
        </ion-button>
      </div>
      <!--  SULINFORM FÓKUSZ (egyelőre csak dev: modul-tema.ts › FOKUSZ_KEPES): a bal sáv MARAD (a user
            kérése), fölötte a Fókusz-sáv: jel, Ugrás… kereső, tanév, profil. Az adminnak saját fejléce van. -->
      <app-sulinform-fokusz-sav *ngIf="fokusz && currentMode === 'SULINFORM' && !adminNezet"
        [oldalak]="appPages" [olvasatlan]="olvasatlanUzenet" [tanevek]="tanevadatok" [tanevNev]="munkatanevNev()"
        (tanevValt)="selectChangedTanev($event)"></app-sulinform-fokusz-sav>
      <ion-router-outlet></ion-router-outlet>
    </div>
  </ion-split-pane>
  <!-- Konrád nyuszi: csak ott látszik, ahol az admin bekapcsolta (lásd konrad.component.ts). -->
  <app-konrad [oldalak]="appPages" [bejelentkezve]="isLoggedIn"></app-konrad>
</ion-app>

<ion-modal style="z-index: 1000" #almenumodal trigger="almenu">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Menüválasztó</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-button *ngFor="let m of menu" style="text-align: left;" color="primary" (click)="openWindow(m.url)" [disabled]="m.disabled" expand="block"><ion-icon slot="start"
            [name]="m.icon" ></ion-icon>{{m.title}}</ion-button>

    </ion-content>
  </ng-template>
</ion-modal>
<ion-modal style="z-index: 1000" #csoportmodal trigger="csoport" [isOpen]="migracio" [canDismiss]="false">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Fiók összekapcsolása</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <ion-card style="background-color: var(--ion-color-primary);color:var(--ion-color-light)">
        <ion-card-content>
          Válassza ki a nevét a listából, hogy régi adatait összekapcsolhassuk új fiókjával!
        </ion-card-content>
      </ion-card><br>
      <div class="input-button-container" style="text-align: center;">

        <ng-select [items]="auth0Users" style="text-align: left;" bindValue="Id" bindLabel="Name" [multiple]="false"
          [closeOnSelect]="true" [(ngModel)]="selectedUser">
        </ng-select><br>
        <ion-button color="primary" (click)="osszekapcsol()" [disabled]="!selectedUser"><ion-icon slot="start"
            name="add"></ion-icon>Mentés</ion-button>
        <ion-button color="danger" (click)="osszekapcsol(0)" [disabled]="selectedUser"><ion-icon slot="start"
            name="close"></ion-icon>Nincs régi fiókom</ion-button>
      </div>


    </ion-content>
  </ng-template>
</ion-modal>
